import { createSlice } from "@reduxjs/toolkit";

const withdraw = createSlice({
  name: "withdraw",
  initialState: {
    withdrawList: [],
  },
  reducers: {
    withdrawListValue: (state, action) => {
      state.withdrawList = action.payload.withdrawValue;
    },
  },
});

export const {
  withdrawListValue,
} = withdraw.actions;
export default withdraw.reducer;
